import { Children, ReactNode } from "react";
import { cn } from "../../../utils/class-names";

interface PanelProps {
  className?: string;
  children?: ReactNode;
}

export function Panel({ className, children }: PanelProps): JSX.Element {
  const array = Children.toArray(children);

  return (
    <div className={cn("flex flex-col gap-0.5", className)}>
      {array.map((child) => (
        <div className="p-5 pb-10 bg-shale-800 first:rounded-t-lg last:rounded-b-lg">
          {child}
        </div>
      ))}
    </div>
  );
}
